(() => {
  const body = document.body;
  const overlay = document.querySelector('[data-screen-overlay]');
  const mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchPanel = document.querySelector('[data-search-panel]');

  const setOverlay = (open) => {
    if (!overlay) return;
    overlay.hidden = !open;
    body.classList.toggle('is-locked', open);
  };

  const closeMobileMenu = () => {
    if (!mobileMenu || !mobileToggle) return;
    mobileMenu.hidden = true;
    mobileToggle.setAttribute('aria-expanded', 'false');
  };

  const closeSearch = () => {
    if (!searchPanel || !searchToggle) return;
    searchPanel.hidden = true;
    searchToggle.setAttribute('aria-expanded', 'false');
  };

  const closePanels = () => {
    closeMobileMenu();
    closeSearch();
    setOverlay(false);
  };

  mobileToggle?.addEventListener('click', () => {
    const willOpen = mobileMenu?.hidden ?? false;
    closeSearch();
    if (mobileMenu) mobileMenu.hidden = !willOpen;
    mobileToggle.setAttribute('aria-expanded', String(willOpen));
    setOverlay(willOpen);
  });

  searchToggle?.addEventListener('click', () => {
    const willOpen = searchPanel?.hidden ?? false;
    closeMobileMenu();
    if (searchPanel) searchPanel.hidden = !willOpen;
    searchToggle.setAttribute('aria-expanded', String(willOpen));
    setOverlay(willOpen);
    if (willOpen) window.setTimeout(() => searchPanel?.querySelector('input[type="search"]')?.focus(), 30);
  });

  searchClose?.addEventListener('click', closePanels);
  overlay?.addEventListener('click', closePanels);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePanels();
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-media-id]')];
    const thumbs = [...gallery.querySelectorAll('[data-media-target]')];
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const target = thumb.dataset.mediaTarget;
        slides.forEach((slide) => {
          const active = slide.dataset.mediaId === target;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      });
    });
  });

  document.querySelectorAll('[data-quantity-selector]').forEach((selector) => {
    const input = selector.querySelector('input[type="number"]');
    selector.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      if (!input) return;
      input.value = String(Math.max(Number(input.min || 1), Number(input.value || 1) - 1));
    });
    selector.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      if (!input) return;
      input.value = String(Number(input.value || 1) + 1);
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const priceContainer = select.closest('[data-product-section]')?.querySelector('[data-product-price]');
      if (priceContainer && option?.dataset.priceMarkup) {
        priceContainer.innerHTML = option.dataset.priceMarkup;
      } else {
        const price = priceContainer?.querySelector('.price span:last-child');
        if (price && option?.dataset.price) price.textContent = option.dataset.price;
      }
    });
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 900) closePanels();
  });
})();
